module.exports = __webpack_public_path__ + "img/dentalfit_15_a.ab8e1e25.jpg";